__turbopack_context__.v({
  "actions": "quiz-cta-banner-membership-first-module__gN-auq__actions",
  "banner": "quiz-cta-banner-membership-first-module__gN-auq__banner",
  "contact": "quiz-cta-banner-membership-first-module__gN-auq__contact",
  "copy": "quiz-cta-banner-membership-first-module__gN-auq__copy",
  "firstScreen": "quiz-cta-banner-membership-first-module__gN-auq__firstScreen",
  "full": "quiz-cta-banner-membership-first-module__gN-auq__full",
  "grain": "quiz-cta-banner-membership-first-module__gN-auq__grain",
  "headline": "quiz-cta-banner-membership-first-module__gN-auq__headline",
  "phones": "quiz-cta-banner-membership-first-module__gN-auq__phones",
  "scene": "quiz-cta-banner-membership-first-module__gN-auq__scene",
  "screenSlot": "quiz-cta-banner-membership-first-module__gN-auq__screenSlot",
  "secondScreen": "quiz-cta-banner-membership-first-module__gN-auq__secondScreen",
  "shade": "quiz-cta-banner-membership-first-module__gN-auq__shade",
  "subtext": "quiz-cta-banner-membership-first-module__gN-auq__subtext",
  "visual": "quiz-cta-banner-membership-first-module__gN-auq__visual",
});
